import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { Button } from '../../components/ui/button';
import { Plus, Pencil, Trash2, X, Star } from 'lucide-react';
import { useToast } from '../../hooks/use-toast';

export default function AdminTestimonials() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(null);
  const { toast } = useToast();

  const load = () => api.testimonials().then(setRows).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      const payload = { ...form, rating: Number(form.rating) };
      delete payload.id_orig;
      if (form.id_orig) await api.admin.testimonialUpdate(form.id_orig, payload);
      else await api.admin.testimonialCreate(payload);
      toast({ title: 'Saved' });
      setForm(null); load();
    } catch { toast({ title: 'Failed', variant: 'destructive' }); }
  };

  const remove = async (id) => {
    if (!window.confirm('Delete?')) return;
    await api.admin.testimonialDelete(id);
    load();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="text-2xl md:text-3xl font-extrabold">Testimonials</h1><p className="text-gray-500 text-sm mt-1">{rows.length} reviews</p></div>
        <Button onClick={() => setForm({ name: '', role: '', course: '', rating: 5, avatar: '', quote: '' })} className="bg-[#6b47dc] hover:bg-[#5a3ac0]"><Plus size={16} className="mr-1" /> New</Button>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {rows.map(r => (
          <div key={r.id} className="bg-white rounded-2xl border border-gray-200 p-5 relative">
            <div className="absolute top-3 right-3 flex gap-1">
              <button onClick={() => setForm({ ...r, id_orig: r.id })} className="p-1.5 text-[#6b47dc] hover:bg-purple-50 rounded"><Pencil size={14} /></button>
              <button onClick={() => remove(r.id)} className="p-1.5 text-red-600 hover:bg-red-50 rounded"><Trash2 size={14} /></button>
            </div>
            <div className="flex gap-1 mb-2">{[...Array(r.rating)].map((_, i) => <Star key={i} size={14} className="fill-amber-400 text-amber-400" />)}</div>
            <p className="text-sm text-gray-700 mb-3">&ldquo;{r.quote}&rdquo;</p>
            <div className="flex items-center gap-3 pt-3 border-t border-gray-100">
              <img src={r.avatar} alt="" className="w-10 h-10 rounded-full object-cover" />
              <div><div className="font-bold text-sm">{r.name}</div><div className="text-xs text-gray-500">{r.role}</div></div>
            </div>
          </div>
        ))}
      </div>

      {form && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => setForm(null)}>
          <div className="bg-white rounded-2xl max-w-md w-full" onClick={(e) => e.stopPropagation()}>
            <div className="p-5 border-b border-gray-100 flex items-center justify-between">
              <h3 className="font-extrabold text-lg">{form.id_orig ? 'Edit testimonial' : 'New testimonial'}</h3>
              <button onClick={() => setForm(null)}><X size={18} /></button>
            </div>
            <div className="p-5 space-y-3">
              <div><label className="text-xs font-bold text-gray-500">Name</label><input className="w-full px-3 py-2 rounded-lg border border-gray-200 outline-none focus:border-[#6b47dc]" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
              <div><label className="text-xs font-bold text-gray-500">Role</label><input className="w-full px-3 py-2 rounded-lg border border-gray-200 outline-none focus:border-[#6b47dc]" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} placeholder="Data Scientist at Google" /></div>
              <div><label className="text-xs font-bold text-gray-500">Course</label><input className="w-full px-3 py-2 rounded-lg border border-gray-200 outline-none focus:border-[#6b47dc]" value={form.course} onChange={(e) => setForm({ ...form, course: e.target.value })} /></div>
              <div><label className="text-xs font-bold text-gray-500">Avatar URL</label><input className="w-full px-3 py-2 rounded-lg border border-gray-200 outline-none focus:border-[#6b47dc]" value={form.avatar} onChange={(e) => setForm({ ...form, avatar: e.target.value })} /></div>
              <div><label className="text-xs font-bold text-gray-500">Rating (1-5)</label><input type="number" min="1" max="5" className="w-full px-3 py-2 rounded-lg border border-gray-200 outline-none focus:border-[#6b47dc]" value={form.rating} onChange={(e) => setForm({ ...form, rating: e.target.value })} /></div>
              <div><label className="text-xs font-bold text-gray-500">Quote</label><textarea rows={4} className="w-full px-3 py-2 rounded-lg border border-gray-200 outline-none focus:border-[#6b47dc]" value={form.quote} onChange={(e) => setForm({ ...form, quote: e.target.value })} /></div>
            </div>
            <div className="p-5 border-t border-gray-100 flex justify-end gap-2">
              <Button variant="outline" onClick={() => setForm(null)}>Cancel</Button>
              <Button onClick={save} className="bg-[#6b47dc] hover:bg-[#5a3ac0]">Save</Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
